export const UserPermission = {
  DASHBOARD: 'dashboard',
  BUY_DATA_BUNDLES: 'buyDataBundles',
  TOPUP: 'topup',
  GLING_GRING_RECHARGE: 'glingGringRecharge',
  SCHEDULED_SUBSCRIPTION: 'scheduledSubscription',
  HISTORY: 'history',
  RESELLER: 'reseller',
  THAI_ESIM: 'thaiEsim',
  PACKAGE: 'package',
  SETTINGS: 'settings'
} as const;

export interface IUserPermission {
  _id: string;
  user: string;
  esimPermissions: {
    dashboard: boolean;
    buyDataBundles: boolean;
    topup: boolean;
    glingGringRecharge: boolean;
    scheduledSubscription: boolean;
    history: boolean;
    reseller: boolean;
    thaiEsim: boolean;
    package: boolean;
    settings: boolean;
  };
  createdAt: Date;
  updatedAt: Date;
}
